<template>
  <v-slide-x-reverse-transition>
    <v-btn
      v-if="filteredProducts.length && searchInput"
      @click="saveAll"
      color="green"
      flat
      :loading="loading"
    >
      <v-icon class="pr-2">save</v-icon>
      <span>Guardar todos</span>
    </v-btn>
  </v-slide-x-reverse-transition>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapGetters("ner", ["filteredProducts"]),
    ...mapState("ner", ["searchInput"])
  },
  methods: {
    ...mapActions("ner", ["saveTaggedFeature"]),
    /**
     * Save all the taggedFeatures generated by the search. We can recognize them
     * because the taggedFeature has properties isFromSearch and notSaved.
     */
    async saveAll() {
      const items = [];
      this.filteredProducts.forEach(product => {
        product.taggedFeatures.forEach(taggedFeature => {
          if (taggedFeature.isFromSearch && taggedFeature.notSaved) {
            items.push({ product, taggedFeature });
          }
        });
      });

      this.loading = true;
      await Promise.all(items.map(item => this.saveTaggedFeature(item)))
        .then(() => this.$notify.success("Guardado con éxito"))
        .catch(() =>
          this.$notify.error(
            "Lo sentimos, ocurrió un error mientras guardábamos los datoss"
          )
        );
      this.loading = false;
    }
  }
};
</script>